import { LOCATION_CHANGE } from 'connected-react-router'
import { matchPath, RouteProps } from 'react-router'
import { AnyAction } from 'redux'
import {
  EnhancedLocationChangeAction,
  LocationPathnameAction,
} from 'src/redux/actions'

export const createFlyoutReducer =
  <S, A extends AnyAction>(
    routeProps: RouteProps | RouteProps[],
    initialState: S,
    coreReducer: (s: S | undefined, a: A) => S,
  ) =>
  (state = initialState, action: A | EnhancedLocationChangeAction): S => {
    const match =
      routeProps instanceof Array
        ? routeProps.some((route) =>
            matchPath(
              (action as LocationPathnameAction)?.location?.pathname,
              route,
            ),
          )
        : matchPath(
            (action as LocationPathnameAction)?.location?.pathname,
            routeProps,
          )

    if (action.type === LOCATION_CHANGE) {
      return initialState
    } else if (
      (action as LocationPathnameAction).isDispatchedFromBackgroundPage ===
        true ||
      !action?.location?.pathname ||
      !match
    ) {
      // asserts here and below that there will be no type LOCATION_CHANGE in A
      return state
    } else {
      return coreReducer(state, action as A)
    }
  }

export const createBackgroundReducer =
  <S, A extends AnyAction>(
    routeProps: RouteProps | RouteProps[],
    initialState: S,
    coreReducer: (s: S | undefined, a: A) => S,
  ) =>
  (state = initialState, action: A | EnhancedLocationChangeAction): S => {
    const match =
      routeProps instanceof Array
        ? routeProps.some((route) =>
            matchPath(
              (action as LocationPathnameAction)?.calculatedBackgroundLocation
                ?.pathname,
              route,
            ),
          )
        : matchPath(
            (action as LocationPathnameAction)?.calculatedBackgroundLocation
              ?.pathname,
            routeProps,
          )

    if (action.type === LOCATION_CHANGE) {
      return (action as EnhancedLocationChangeAction).payload
        .shouldResetBackgroundState
        ? initialState
        : state
    } else if (
      (action as LocationPathnameAction).isDispatchedFromBackgroundPage ===
        false ||
      !action?.calculatedBackgroundLocation?.pathname ||
      !match
    ) {
      // asserts here and below that there will be no type LOCATION_CHANGE in A
      return state
    } else {
      return coreReducer(state, action as A)
    }
  }
